import { supabase } from './supabase';

/**
 * Check if the current user is an admin using only hardcoded user ID
 * This completely bypasses RLS policies to avoid infinite recursion
 */
export async function checkIsAdmin(): Promise<boolean> {
  try {
    // Get the current user
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    
    if (userError || !user) {
      console.error('No authenticated user found');
      return false;
    }

    // Hardcoded admin user ID to bypass RLS issues completely
    const ADMIN_USER_ID = '93794bbb-34c2-48f4-a292-1f55434bcdba'; // Your user ID
    
    return user.id === ADMIN_USER_ID;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

/**
 * Get the current user's profile - DISABLED to avoid RLS recursion
 * Returns null until RLS policies are fixed
 */
export async function getCurrentUserProfile() {
  // Temporarily disabled to avoid infinite recursion
  console.log('getCurrentUserProfile disabled due to RLS recursion issues');
  return null;
} 